import { UNKNOWN_FACT } from "@shared/labels.ts";
import { formatMoney } from "@shared/money.ts";
import type { MoneyValue } from "@shared/schema.ts";
import { mapsSearchUrl as sharedMapsSearchUrl, placeDirectionsUrl, safeHttpUrl as sharedSafeHttpUrl } from "@shared/place-links.ts";

export { placeDirectionsUrl };
export const mapsSearchUrl = sharedMapsSearchUrl;
export const safeHttpUrl = sharedSafeHttpUrl;

export function moneyLabel(value: MoneyValue | null | undefined, fallback = UNKNOWN_FACT) {
  if (!value) return fallback;
  return formatMoney(value);
}

export function directionsUrl(mapsUrl: string | null | undefined, query: string): string {
  return sharedSafeHttpUrl(mapsUrl) ?? sharedMapsSearchUrl(query);
}

/** Opens a WhatsApp draft. Never sends on its own. */
export function whatsappDraftUrl(phone: string, text: string) {
  const digits = phone.replace(/[^\d]/g, "");
  if (!digits) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}

export function airlineStatusUrl(airline: string, number: string) {
  if (airline.toLowerCase().includes("malaysia")) {
    return `https://www.malaysiaairlines.com/hq/en/travel-info/flight-status.html`;
  }
  if (airline.toLowerCase().includes("bangkok")) {
    return `https://www.bangkokair.com/flight-status`;
  }
  return `https://www.google.com/search?q=${encodeURIComponent(`${airline} ${number} flight status`)}`;
}

export async function copyText(value: string): Promise<"copied" | "denied"> {
  try {
    await navigator.clipboard.writeText(value);
    return "copied";
  } catch {
    return "denied";
  }
}
